import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadModule } from 'ng2-file-upload';
import { EmptyComponent } from './empty.component';
import { STableComponent } from './comps/s-table/s-table.component';
import { SafePipe } from './directives/safe';
import { SafeHtmlPipe } from './directives/safeHtml';
import { BoolPipe } from './directives/bool';
import { MyDatePipe } from './directives/my-date';
import { CropTextPipe } from './directives/cropText';
import { DownloadFileDirective } from './directives/download-file';
import { ShowFileDirective } from './directives/show-file';
import { UiSwitchComponent, UiSwitchModule } from 'ngx-toggle-switch';
import { FloatDialog } from './directives/float-dialog';
import { SortableHeader } from './directives/sortable.directive';
import { YesNoComponent } from './modals/yes-no/yes-no.component';
import { DateRangeComponent } from './comps/date-range/date-range.component';
import { SInputDateComponent } from './comps/s-input-date/s-input-date.component';
import { SSelectComponent } from './comps/s-select/s-select.component';
import { SInputComponent } from './comps/s-input/s-input.component';
import { SInputGroupComponent } from './comps/s-input-group/s-input-group.component';
import { SInputTrComponent } from './comps/s-input-tr/s-input-tr.component';
import { RightMenuComponent } from './comps/right-menu/right-menu.component';
import { UploaderComponent } from './comps/uploader/uploader.component';
import { ImagesModalComponent } from './modals/images-modal/images-modal.component';
import { LogModalComponent } from './modals/log-modal/log-modal.component';
import { DashboardCounterComponent } from './comps/dashboard-counter/dashboard-counter.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DbComponent } from './db/db.component';
import { NewsModalComponent } from './modals/news-modal/news-modal.component';
import { DateRangeBtnsComponent } from './comps/date-range-btns/date-range-btns.component';
import { SRadioButtonsComponent } from './comps/s-radio-buttons/s-radio-buttons.component';
import { WebcamComponent, WebcamModule } from 'ngx-webcam';
import { SInputDayIntervalComponent } from './comps/s-input-day-interval/s-input-day-interval.component';
import { PhotoModalComponent } from './modals/photo-modal/photo-modal.component';
import { IFrameComponent } from './comps/i-frame/i-frame.component';
import { UserComponent } from './users/user/user.component';
import { UsersComponent } from './users/users.component';
import { GroupComponent } from './users/group/group.component';
import { FileFloatModalComponent } from './modals/file-float-modal/file-float-modal.component';
import { ProgressModalComponent } from './modals/progress-modal/progress-modal.component';
import { RedirectorComponent } from './comps/redirector/redirector.component';
import { MyHoursPipe } from './directives/my-hours';
import { UserNotificationsComponent } from './comps/user-notifications/user-notifications.component';
import { PreventEnterDirective } from './directives/prevent-enter';
import { TextareaAutoresize } from './directives/textarea-autoresize';

@NgModule({
  declarations: [
    STableComponent,
    SafePipe,
    SafeHtmlPipe,
    BoolPipe,
    PreventEnterDirective,
    MyDatePipe,
    CropTextPipe,
    DownloadFileDirective,
    ShowFileDirective,
    TextareaAutoresize,
    FloatDialog,
    SortableHeader,
    YesNoComponent,
    DateRangeComponent,
    IFrameComponent,
    SInputDateComponent,
    SSelectComponent,
    SInputComponent,
    SInputGroupComponent,
    SInputTrComponent,
    RightMenuComponent,
    UploaderComponent,
    ImagesModalComponent,
    LogModalComponent,
    DashboardCounterComponent,
    EmptyComponent,
    PhotoModalComponent,
    UserComponent,
    UsersComponent,
    GroupComponent,
    DbComponent,
    NewsModalComponent,
    DateRangeBtnsComponent,
    SRadioButtonsComponent,
    SInputDayIntervalComponent,
    FileFloatModalComponent,
    ProgressModalComponent,
    RedirectorComponent,
    MyHoursPipe,
    UserNotificationsComponent
  ],
  imports: [
    CommonModule,
    //FormsModule,
    NgSelectModule,
    NgbModule,
    TranslateModule,
    UiSwitchModule,
    FileUploadModule,
    WebcamModule,
  ],
  exports: [
    STableComponent,
    SafePipe,
    SafeHtmlPipe,
    BoolPipe,
    PreventEnterDirective,
    MyDatePipe,
    CropTextPipe,
    DownloadFileDirective,
    ShowFileDirective,
    TextareaAutoresize,
    FloatDialog,
    SortableHeader,
    UiSwitchComponent,
    DateRangeComponent,
    IFrameComponent,
    SInputDateComponent,
    SSelectComponent,
    SInputComponent,
    SInputGroupComponent,
    SInputTrComponent,
    RightMenuComponent,
    UploaderComponent,
    ImagesModalComponent,
    LogModalComponent,
    DashboardCounterComponent,
    EmptyComponent,
    WebcamComponent,
    PhotoModalComponent,
    UserComponent,
    UsersComponent,
    GroupComponent,
    DbComponent,
    NewsModalComponent,
    DateRangeBtnsComponent,
    SRadioButtonsComponent,
    SInputDayIntervalComponent,
    FileFloatModalComponent,
    ProgressModalComponent,
    RedirectorComponent,
    MyHoursPipe,
    UserNotificationsComponent
  ]
})
export class SModule { }
